import axios from '../../utils/axios';
import CRUD from './crud'

const eventTickets = new CRUD('ticket-payments', 'superior-judge')

export default Object.assign(
    eventTickets,
    {
        reducers: {
            ...eventTickets.reducers
        },

        sendMessage: (id, message) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/ticket-payments/${id}/message`, {message: message})
                } catch (error) {
                    console.error(error);
                }
            };
        },

        approve: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/ticket-payments/${id}/approve`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        decline: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/ticket-payments/${id}/decline`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        deleteFile: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/ticket-payments/${id}/delete-file`);
                } catch (error) {
                    console.error(error);
                    throw error;
                }
            };
        },

        prices: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/ticket-payments/prices`, {
                        params: {
                            'filters': {
                                id_tournament: id
                            }
                        }
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        report: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/ticket-payments/report?id_tournament=${id}`, { responseType: 'blob' })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        updateItem: (id, data) => {
            return async (dispatch) => {
                try {
                    return axios.put(`/superior-judge/ticket-payments/${id}`, data);
                } catch (error) {
                    console.error(error);
                    throw error;
                }
            };
        },
    }
)
